import React from 'react';
import { MapPin, Clock } from 'lucide-react';

// Импорт данных о городах
import { russianCities, internationalCities } from './data/cities';

const LayoverSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  // Объединяем списки российских и международных городов
  const cities = [...russianCities, ...internationalCities].sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div className="mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <MapPin className="w-5 h-5 mr-2 text-blue-500" />
        Параметры пересадки
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Город пересадки */}
        <div>
          <label htmlFor="layoverCity" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <MapPin className="w-4 h-4 mr-2 text-blue-500" />
            Город пересадки
          </label>
          <select
            id="layoverCity"
            name="layoverCity"
            value={formData.layoverCity}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.layoverCity ? 'input-error' : ''}`}
          >
            <option value="">Выберите город</option>
            <optgroup label="Города России">
              {russianCities.map((city) => (
                <option 
                  key={city.id} 
                  value={city.name}
                  disabled={city.name === formData.departureCity || city.name === formData.arrivalCity}
                >
                  {city.name}
                </option>
              ))}
            </optgroup>
            <optgroup label="Международные города">
              {internationalCities.map((city) => (
                <option 
                  key={city.id} 
                  value={city.name}
                  disabled={city.name === formData.departureCity || city.name === formData.arrivalCity}
                >
                  {city.name}
                </option>
              ))}
            </optgroup>
          </select>
          {errors.layoverCity && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.layoverCity}
            </p>
          )}
        </div>

        {/* Длительность пересадки */}
        <div>
          <label htmlFor="layoverDuration" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Clock className="w-4 h-4 mr-2 text-blue-500" />
            Длительность пересадки (часов)
          </label>
          <input
            type="number"
            id="layoverDuration"
            name="layoverDuration"
            value={formData.layoverDuration}
            onChange={handleInputChange}
            min="1"
            max="48"
            step="0.5"
            className={`form-input w-full ${errors.layoverDuration ? 'input-error' : ''}`}
          />
          {errors.layoverDuration && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.layoverDuration}
            </p>
          )}
        </div>
      </div>

      {/* Информационный блок о пересадках */}
      <div className="mt-4 bg-blue-100 dark:bg-blue-900/30 p-3 rounded-lg border border-blue-200 dark:border-blue-800">
        <div className="flex items-start">
          <Clock className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
              О пересадках
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              Минимальное рекомендуемое время пересадки составляет 1,5 часа для внутренних рейсов
              и 2,5 часа для международных. Длительные пересадки (более 6 часов) могут дать возможность
              осмотреть город пересадки.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LayoverSection;